import "core-js/modules/es6.symbol.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.array.iterator.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import '@web/shared-digital-library/icons/svg-originals/chevron-left.svg';
import Slide from './Slide.vue';
import SimpleParagraph from '~/components/atoms/Editorial/SimpleParagraph.vue';
import RegularTitle from '~/components/atoms/Global/RegularTitle.vue';
import { formatPrismicImage } from '~/helpers/image-helper';
export default {
  name: 'SliderSwipe',
  components: {
    RegularTitle,
    SimpleParagraph,
    Slide
  },
  props: {
    payload: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      selectedSlide: 1,
      observer: null,
      observerReady: false,
      isLeftButtonVisible: false,
      isRightButtonVisible: true
    };
  },
  computed: {
    primarySlice() {
      var _this$payload;
      return (_this$payload = this.payload) === null || _this$payload === void 0 ? void 0 : _this$payload.primary;
    },
    labelImageBefore() {
      var _this$payload2, _this$payload2$primar;
      return ((_this$payload2 = this.payload) === null || _this$payload2 === void 0 ? void 0 : (_this$payload2$primar = _this$payload2.primary) === null || _this$payload2$primar === void 0 ? void 0 : _this$payload2$primar.labelImageBefore) || null;
    },
    labelImageAfter() {
      var _this$payload3, _this$payload3$primar;
      return ((_this$payload3 = this.payload) === null || _this$payload3 === void 0 ? void 0 : (_this$payload3$primar = _this$payload3.primary) === null || _this$payload3$primar === void 0 ? void 0 : _this$payload3$primar.labelImageAfter) || null;
    },
    payloadInterface() {
      var _this$payload$primary, _this$payload4, _this$payload4$primar, _this$payload$primary2, _this$payload5, _this$payload5$primar, _this$payload$primary3, _this$payload6, _this$payload6$primar, _this$payload7;
      return {
        primarySlice: {
          title: (_this$payload$primary = (_this$payload4 = this.payload) === null || _this$payload4 === void 0 ? void 0 : (_this$payload4$primar = _this$payload4.primary) === null || _this$payload4$primar === void 0 ? void 0 : _this$payload4$primar.title) !== null && _this$payload$primary !== void 0 ? _this$payload$primary : [],
          paragraph: (_this$payload$primary2 = (_this$payload5 = this.payload) === null || _this$payload5 === void 0 ? void 0 : (_this$payload5$primar = _this$payload5.primary) === null || _this$payload5$primar === void 0 ? void 0 : _this$payload5$primar.paragraph) !== null && _this$payload$primary2 !== void 0 ? _this$payload$primary2 : [],
          background_color: (_this$payload$primary3 = (_this$payload6 = this.payload) === null || _this$payload6 === void 0 ? void 0 : (_this$payload6$primar = _this$payload6.primary) === null || _this$payload6$primar === void 0 ? void 0 : _this$payload6$primar.background_color) !== null && _this$payload$primary3 !== void 0 ? _this$payload$primary3 : '#fff'
        },
        items: (_this$payload7 = this.payload) === null || _this$payload7 === void 0 ? void 0 : _this$payload7.items.map(item => {
          var _formatPrismicImage, _item$avatar, _item$avatar$alt, _item$avatar2, _item$avatar_title, _item$avatar_subtitle, _formatPrismicImage2, _item$image, _formatPrismicImage3, _item$image2, _item$image$alt, _item$image3, _item$tag, _item$tag2, _item$title, _item$description, _item$cta, _item$cta_theme, _item$url, _item$event_category, _item$event_action, _item$event_label, _item$imageBefore, _item$imageBefore2, _item$imageBefore3, _item$imageBefore4, _item$imageBefore$alt, _item$imageBefore5, _item$imageAfter, _item$imageAfter2, _item$imageAfter3, _item$imageAfter4, _item$imageAfter$alt, _item$imageAfter5;
          return _objectSpread(_objectSpread({
            avatar: {
              small: (_formatPrismicImage = formatPrismicImage(item === null || item === void 0 ? void 0 : (_item$avatar = item.avatar) === null || _item$avatar === void 0 ? void 0 : _item$avatar.url, ['w_90,dpr_2'])) !== null && _formatPrismicImage !== void 0 ? _formatPrismicImage : '',
              alt: (_item$avatar$alt = item === null || item === void 0 ? void 0 : (_item$avatar2 = item.avatar) === null || _item$avatar2 === void 0 ? void 0 : _item$avatar2.alt) !== null && _item$avatar$alt !== void 0 ? _item$avatar$alt : ''
            },
            avatarTitle: (_item$avatar_title = item === null || item === void 0 ? void 0 : item.avatar_title) !== null && _item$avatar_title !== void 0 ? _item$avatar_title : '',
            avatarSubtitle: (_item$avatar_subtitle = item === null || item === void 0 ? void 0 : item.avatar_subtitle) !== null && _item$avatar_subtitle !== void 0 ? _item$avatar_subtitle : '',
            image: {
              small: (_formatPrismicImage2 = formatPrismicImage(item === null || item === void 0 ? void 0 : (_item$image = item.image) === null || _item$image === void 0 ? void 0 : _item$image.url, ['w_130,dpr_2'])) !== null && _formatPrismicImage2 !== void 0 ? _formatPrismicImage2 : '',
              large: (_formatPrismicImage3 = formatPrismicImage(item === null || item === void 0 ? void 0 : (_item$image2 = item.image) === null || _item$image2 === void 0 ? void 0 : _item$image2.url, [['w_1440', 'ar_16:9', 'c_fill']])) !== null && _formatPrismicImage3 !== void 0 ? _formatPrismicImage3 : '',
              alt: (_item$image$alt = item === null || item === void 0 ? void 0 : (_item$image3 = item.image) === null || _item$image3 === void 0 ? void 0 : _item$image3.alt) !== null && _item$image$alt !== void 0 ? _item$image$alt : ''
            },
            tag1: (_item$tag = item === null || item === void 0 ? void 0 : item.tag1) !== null && _item$tag !== void 0 ? _item$tag : '',
            tag2: (_item$tag2 = item === null || item === void 0 ? void 0 : item.tag2) !== null && _item$tag2 !== void 0 ? _item$tag2 : '',
            title: (_item$title = item === null || item === void 0 ? void 0 : item.title) !== null && _item$title !== void 0 ? _item$title : '',
            description: (_item$description = item === null || item === void 0 ? void 0 : item.description) !== null && _item$description !== void 0 ? _item$description : '',
            cta: (_item$cta = item === null || item === void 0 ? void 0 : item.cta) !== null && _item$cta !== void 0 ? _item$cta : '',
            ctaTheme: (_item$cta_theme = item === null || item === void 0 ? void 0 : item.cta_theme) !== null && _item$cta_theme !== void 0 ? _item$cta_theme : 'dark',
            link: (_item$url = item === null || item === void 0 ? void 0 : item.url) !== null && _item$url !== void 0 ? _item$url : '',
            tracking: {
              event_category: (_item$event_category = item === null || item === void 0 ? void 0 : item.event_category1) !== null && _item$event_category !== void 0 ? _item$event_category : '',
              event_action: (_item$event_action = item === null || item === void 0 ? void 0 : item.event_action1) !== null && _item$event_action !== void 0 ? _item$event_action : '',
              event_label: (_item$event_label = item === null || item === void 0 ? void 0 : item.event_label1) !== null && _item$event_label !== void 0 ? _item$event_label : ''
            }
          }, (item === null || item === void 0 ? void 0 : item.imageBefore) && {
            imageBefore: _objectSpread(_objectSpread({}, (item === null || item === void 0 ? void 0 : item.imageBefore) || null), {}, {
              imgSrcset: "".concat(formatPrismicImage(item === null || item === void 0 ? void 0 : (_item$imageBefore = item.imageBefore) === null || _item$imageBefore === void 0 ? void 0 : _item$imageBefore.url, ['w_375', 'c_fill']), " 375w,\n            ").concat(formatPrismicImage(item === null || item === void 0 ? void 0 : (_item$imageBefore2 = item.imageBefore) === null || _item$imageBefore2 === void 0 ? void 0 : _item$imageBefore2.url, ['w_750,c_fill']), " 750w,\n            ").concat(formatPrismicImage(item === null || item === void 0 ? void 0 : (_item$imageBefore3 = item.imageBefore) === null || _item$imageBefore3 === void 0 ? void 0 : _item$imageBefore3.url, ['w_1000,c_fill']), " 1000w,\n            ").concat(formatPrismicImage(item === null || item === void 0 ? void 0 : (_item$imageBefore4 = item.imageBefore) === null || _item$imageBefore4 === void 0 ? void 0 : _item$imageBefore4.url, ['w_1600,c_fill']), " 1600w"),
              alt: (_item$imageBefore$alt = item === null || item === void 0 ? void 0 : (_item$imageBefore5 = item.imageBefore) === null || _item$imageBefore5 === void 0 ? void 0 : _item$imageBefore5.alt) !== null && _item$imageBefore$alt !== void 0 ? _item$imageBefore$alt : ''
            })
          }), (item === null || item === void 0 ? void 0 : item.imageAfter) && {
            imageAfter: {
              imgSrcset: "".concat(formatPrismicImage(item === null || item === void 0 ? void 0 : (_item$imageAfter = item.imageAfter) === null || _item$imageAfter === void 0 ? void 0 : _item$imageAfter.url, ['w_1440', 'c_fill']), " 375w,\n            ").concat(formatPrismicImage(item === null || item === void 0 ? void 0 : (_item$imageAfter2 = item.imageAfter) === null || _item$imageAfter2 === void 0 ? void 0 : _item$imageAfter2.url, ['w_750,c_fill']), " 750w,\n            ").concat(formatPrismicImage(item === null || item === void 0 ? void 0 : (_item$imageAfter3 = item.imageAfter) === null || _item$imageAfter3 === void 0 ? void 0 : _item$imageAfter3.url, ['w_1000,c_fill']), " 1000w,\n            ").concat(formatPrismicImage(item === null || item === void 0 ? void 0 : (_item$imageAfter4 = item.imageAfter) === null || _item$imageAfter4 === void 0 ? void 0 : _item$imageAfter4.url, ['w_1600,c_fill']), " 1600w"),
              alt: (_item$imageAfter$alt = item === null || item === void 0 ? void 0 : (_item$imageAfter5 = item.imageAfter) === null || _item$imageAfter5 === void 0 ? void 0 : _item$imageAfter5.alt) !== null && _item$imageAfter$alt !== void 0 ? _item$imageAfter$alt : ''
            }
          });
        })
      };
    }
  },
  mounted() {
    var observerOpts = {
      root: this.$refs.slider,
      rootMargin: '0% -50%',
      threshold: 0
    };
    this.observer = new IntersectionObserver(this.observerCallback, observerOpts);
    this.setObserver();
    this.$refs.slider.addEventListener('scroll', this.onSliderScroll);
  },
  updated() {
    this.setObserver();
  },
  beforeDestroy() {
    if (this.observer) this.observer.disconnect();
  },
  methods: {
    setObserver() {
      var _this$$refs$slide;
      if (this.observerReady) return;
      if (((_this$$refs$slide = this.$refs.slide) === null || _this$$refs$slide === void 0 ? void 0 : _this$$refs$slide.length) > 0) {
        this.$refs.slide.forEach(slide => this.observer.observe(slide));
        this.observerReady = true;
      }
    },
    observerCallback(entries) {
      entries.forEach(_ref => {
        var {
          isIntersecting,
          target
        } = _ref;
        if (!isIntersecting) return;
        var index = this.$refs.slide.indexOf(target);
        this.selectedSlide = index + 1;
      });
    },
    scrollTo(index) {
      var {
        slider
      } = this.$refs;
      var {
        offsetLeft,
        offsetWidth: slideWidth
      } = this.$refs.slide[index];
      var {
        offsetWidth: sliderWidth
      } = slider;
      var left = offsetLeft - (sliderWidth - slideWidth) / 2;
      slider.scrollLeft = left;
    },
    onSliderScroll() {
      var {
        slider
      } = this.$refs;
      this.isLeftButtonVisible = slider.scrollLeft > 0;
      this.isRightButtonVisible = slider.scrollLeft < slider.scrollWidth - slider.offsetWidth - 5;
    },
    onLeftClick(e) {
      this.scrollTo(this.selectedSlide - 2);
    },
    onRightClick(e) {
      this.scrollTo(this.selectedSlide);
    }
  }
};